module.exports = __webpack_public_path__ + "static/img/none.fc27b25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/train/none.png
// module id = t2Up
// module chunks = 38